import {
  Target,
  Palette,
  Monitor,
  Megaphone,
  ArrowUpRight,
} from "lucide-react";
import { SERVICES } from "@/components/landing/content";

const ICONS = { Target, Palette, Monitor, Megaphone };

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="max-w-3xl">
          <span className="inline-block text-xs uppercase tracking-[0.22em] font-semibold text-orange-600">
            What we do
          </span>
          <h2
            data-testid="services-heading"
            className="font-display mt-3 text-4xl md:text-5xl lg:text-6xl font-extrabold text-slate-900 leading-[1.05]"
          >
            Strategy, design and ads —{" "}
            <span className="brand-text-gradient">built to scale.</span>
          </h2>
          <p className="mt-5 text-lg text-slate-600 max-w-2xl font-body">
            Four focused services that work together to turn your business into
            a brand customers remember and recommend.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-5 md:gap-6">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            const isAccent = i === 1 || i === 2;
            return (
              <article
                key={s.title}
                data-testid={`service-card-${i}`}
                className={`lift group relative overflow-hidden rounded-3xl border border-slate-200 bg-white p-7 md:p-9`}
              >
                <div className="flex items-start justify-between">
                  <span
                    className={`inline-flex h-12 w-12 items-center justify-center rounded-2xl ${
                      isAccent
                        ? "bg-orange-100 text-orange-700"
                        : "bg-blue-100 text-blue-800"
                    }`}
                  >
                    <Icon size={22} />
                  </span>
                  <span className="font-display text-3xl font-extrabold text-slate-200 group-hover:text-slate-300 transition-colors">
                    0{i + 1}
                  </span>
                </div>

                <h3 className="font-display mt-6 text-2xl md:text-3xl font-extrabold text-slate-900">
                  {s.title}
                </h3>
                <p className="mt-3 text-slate-600 leading-relaxed font-body">
                  {s.desc}
                </p>

                <a
                  href="#contact"
                  data-testid={`service-cta-${i}`}
                  className="mt-7 inline-flex items-center gap-1.5 text-sm font-semibold text-slate-900 border-b border-slate-300 hover:border-orange-500 hover:text-orange-700 transition-colors"
                >
                  Talk to us about this
                  <ArrowUpRight size={16} />
                </a>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
